import { themeGet } from '@styled-system/theme-get'
import styled, { css, keyframes } from 'styled-components'
import { ifProp } from 'styled-tools'

export const loaderSize = 10
const loaderBorderWidth = 2

const grow = keyframes`
  0% {
    transform: translateY(-50%) scale(1);
    opacity: 1;
  }

  50% {
    transform: translateY(-50%) scale(1.8);
    opacity: 0.5;
  }

  100% {
    transform: translateY(-50%) scale(1);
    opacity: 1;
  }
`

const ButtonLoadingIndicator = styled.i<{ invert?: boolean }>`
  animation: ${grow} 600ms infinite;
  animation-delay: 220ms;
  display: block;
  opacity: 0;
  position: relative;

  &:before {
    border-radius: ${loaderSize}px;
    border: ${loaderBorderWidth}px solid
      ${ifProp(
        'invert',
        css`
          ${themeGet('colors.accent4')}
        `,
        css`
          ${themeGet('colors.white')}
        `,
      )};
    content: '';
    display: block;
    height: ${loaderSize - loaderBorderWidth * 2}px;
    width: ${loaderSize - loaderBorderWidth * 2}px;
  }
`

export default ButtonLoadingIndicator
